import {
    PageContainer
} from "ncore-ui-kit";
import {
    StateCard
} from "../../../components";

const RestrictedView = () => {
    return <PageContainer
        isScrollable={false}
        backgroundColor="subtle"
        isWrapSafeareaContext={true}
    >
        <StateCard />
    </PageContainer>;
};

export default RestrictedView;
